//https://codesandbox.io/s/gallant-leftpad-8kvtn7?file=/src/App.js:0-80
//https://www.npmjs.com/package/react-tooltip
import { useState } from "react";
import React from "react";
import Eingaben from "./EingabeKomponenten/Eingaben";
import Ergebnisse from "./ErgebnisermittlungKomponenten/Ergebnisse";
import BruttoNettoContext from "./BruttoNettoContext";
import BnrLogo from "../../../src/assets/BnrLogo.svg";
import ErgSz13 from "../../components/BruttoNettoRechnerKomponenten/ErgebnisermittlungKomponenten/ErgSz13";
import ErgSz14 from "../../components/BruttoNettoRechnerKomponenten/ErgebnisermittlungKomponenten/ErgSz14";
import ErgDGZ from "../../components/BruttoNettoRechnerKomponenten/ErgebnisermittlungKomponenten/ErgDGZ";
import ErgJaHo from "./ErgebnisermittlungKomponenten/ErgJaHo.js";
import { Tooltip as ReactTooltip } from "react-tooltip";

const initialBruttoNettoState = {
  bruttoGehalt: 1859.11,
  abzugsBetrag: 11,
  steuerAbzug: 38.58,
  sVsgBeitrag: 0,
  sVsgSatz: 0,
  steuer: 0,
  nettoGehalt: 0,
  sz13SVsgSatz: 0,
  sz13SVsgBeitrag: 0,
  steuerSZ13: 0,
  nettoSZ13: 0,
  sz14SVsgSatz: 0,
  sz14SVsgBeitrag: 0,
  szEStFreiBtg: 620,
  steuerSZ14: 0,
  nettoSZ14: 0,

  ergDGZkd: 0,
  extDGZkdr: 0,
  ergDGZkdNetto: 0,
  ergDGSV: 0,
  ergDGMV: 0,
  ergDGgesamt: 0,
  ergJaHoNetto: 0,
  ergJaHoBrutto: 0,

  // sz13
  //sz14
  //DGZ
  //JH
};

export default function RechnerContainer() {
  const [bruttoNettoState, setBruttoNettoState] = useState(
    initialBruttoNettoState
  );

  function handleBruttoNettoState(handleType, value) {
    if (handleType === "szEStFreiBtg") {
      setBruttoNettoState((prevState) => ({
        ...prevState,
        szEStFreiBtg: parseFloat(value),
      }));
    }

    if (handleType === "ergJaHoBrutto") {
      setBruttoNettoState((prevState) => ({
        ...prevState,
        ergJaHoBrutto: parseFloat(value),
      }));
    }
    if (handleType === "ergDGgesamt") {
      setBruttoNettoState((prevState) => ({
        ...prevState,
        ergDGgesamt: parseFloat(value),
      }));
    }
    if (handleType === "ergDGMV") {
      setBruttoNettoState((prevState) => ({
        ...prevState,
        ergDGMV: parseFloat(value),
      }));
    }
    if (handleType === "ergDGSV") {
      setBruttoNettoState((prevState) => ({
        ...prevState,
        ergDGSV: parseFloat(value),
      }));
    }
    if (handleType === "ergDGZkd") {
      setBruttoNettoState((prevState) => ({
        ...prevState,
        ergDGZkd: parseFloat(value),
      }));
    }
    if (handleType === "ergDGZkdNetto") {
      setBruttoNettoState((prevState) => ({
        ...prevState,
        ergDGZkdNetto: parseFloat(value),
      }));
    }
    if (handleType === "ergDGZkdr") {
      setBruttoNettoState((prevState) => ({
        ...prevState,
        ergDGZkdr: parseFloat(value),
      }));
    }
    if (handleType === "ergJaHoNetto") {
      setBruttoNettoState((prevState) => ({
        ...prevState,
        ergJaHoNetto: parseFloat(value),
      }));
    }
    if (handleType === "nettoSZ13") {
      setBruttoNettoState((prevState) => ({
        ...prevState,
        nettoSZ13: parseFloat(value),
      }));
    }
    if (handleType === "steuerSZ13") {
      setBruttoNettoState((prevState) => ({
        ...prevState,
        steuerSZ13: parseFloat(value),
      }));
    }
    if (handleType === "sz13SVsgSatz") {
      setBruttoNettoState((prevState) => ({
        ...prevState,
        sz13SVsgSatz: parseFloat(value),
      }));
    }
    if (handleType === "sz13SVsgBeitrag") {
      setBruttoNettoState((prevState) => ({
        ...prevState,
        sz13SVsgBeitrag: parseFloat(value),
      }));
    }

    if (handleType === "nettoSZ14") {
      setBruttoNettoState((prevState) => ({
        ...prevState,
        nettoSZ14: parseFloat(value),
      }));
    }
    if (handleType === "steuerSZ14") {
      setBruttoNettoState((prevState) => ({
        ...prevState,
        steuerSZ14: parseFloat(value),
      }));
    }
    if (handleType === "sz14SVsgSatz") {
      setBruttoNettoState((prevState) => ({
        ...prevState,
        sz14SVsgSatz: parseFloat(value),
      }));
    }
    if (handleType === "sz14SVsgBeitrag") {
      setBruttoNettoState((prevState) => ({
        ...prevState,
        sz14SVsgBeitrag: parseFloat(value),
      }));
    }
    if (handleType === "bruttoGehalt") {
      setBruttoNettoState((prevState) => ({
        ...prevState,
        bruttoGehalt: parseFloat(value),
      }));
    }
    if (handleType === "abzugsBetrag") {
      setBruttoNettoState((prevState) => ({
        ...prevState,
        abzugsBetrag: parseFloat(value),
      }));
    }
    if (handleType === "steuerAbzug") {
      setBruttoNettoState((prevState) => ({
        ...prevState,
        steuerAbzug: parseFloat(value),
      }));
    }
    if (handleType === "sVsgBeitrag") {
      console.log("sVsgBeitrag", value);
      setBruttoNettoState((prevState) => ({
        ...prevState,
        sVsgBeitrag: parseFloat(value),
      }));
    }
    if (handleType === "sVsgSatz") {
      setBruttoNettoState((prevState) => ({
        ...prevState,
        sVsgSatz: parseFloat(value),
      }));
    }
    if (handleType === "steuer") {
      console.log("handleType steuer", value);
      setBruttoNettoState((prevState) => ({
        ...prevState,
        steuer: parseFloat(value),
      }));
    }
    if (handleType === "nettoGehalt") {
      setBruttoNettoState((prevState) => ({
        ...prevState,
        nettoGehalt: parseFloat(value),
      }));
    }
  }

  const bruttoNettoCtxValues = {
    bruttoNettoState,
    handleBruttoNettoState,
  };

  return (
    <BruttoNettoContext.Provider value={bruttoNettoCtxValues}>
      <div>
        {/* <h1>Rechen-Apps</h1> */}
        <div className="nk-lohnzettel">
          <div className="nk_header">
            <img className="bnrLogo" src={BnrLogo} alt="logo"></img>

            <h2 className="title">
              Brutto-Netto-Rechner <span data-tooltip-id="tooltip1">ℹ️</span>
            </h2>
            <p style={{ color: "#058785" }}>Landarbeiter NÖ, Stand 1.1.2024</p>
          </div>
          <div className="nk_body">
            <div className="spalte1">
              <Eingaben />
              <Ergebnisse />
            </div>
            <div className="spalte2">
              <ErgSz13 />
              <ErgSz14 />
            </div>
            <div className="spalte3">
              <ErgDGZ />
              <ErgJaHo />
            </div>
          </div>
        </div>

        <ReactTooltip id="tooltip1" place="bottom" variant="info">
          <p>Alle Angaben ohne Gewähr. </p>
          <p>
            SV-Reduktion bei Lehrlingen & Personen über 60 nicht berücksichtigt!
          </p>
        </ReactTooltip>
      </div>
    </BruttoNettoContext.Provider>
  );
}
